<template>
    <div class="grid grid-cols-12 gap-4 mb-6">
        <div
            class="
                relative
                credit-score
                col-span-12
                lg:col-span-6
                xl:col-span-4
                rounded-lg
                bg-white dark:bg-slate-800
                px-4
                pt-5
                pb-12
                shadow
                sm:px-6
                sm:pt-6
                border border-gray-200 dark:border-slate-700
                flex flex-col
                justify-between
            "
        >
            <h3
                :class="[
                    'text-lg font-medium leading-7 text-slate-800 dark:text-slate-100 z-10',
                    emptyState ? 'absolute top-5 left-4 sm:left-6' : ''
                ]"
                style="filter: none; opacity: 1;"
            >
                Current score
            </h3>

            <!-- Loading state for meter area only -->
            <LoadingState :loading="loadingUserCreditScore" />
            
            <!-- Content when not loading -->
            <div v-if="!loadingUserCreditScore">
                <div :class="{ emptyState }">
                    <div class="relative mb-6">
                        <creditscore-meter
                            :latest-score="userScoreData && userScoreData.latest_score ? userScoreData.latest_score : 0"
                            :empty-state="emptyState"
                        ></creditscore-meter>
                    </div>

                    <div>
                        <div
                            v-if="!emptyState && userScoreData && userScoreData.last_updated_days < 60"
                            class="flex w-full items-center justify-between px-2"
                        >
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="
                credit-score-history
                col-span-12
                lg:col-span-6
                xl:col-span-8
                rounded-lg
                bg-white dark:bg-slate-800
                px-4
                pt-5
                pb-12
                shadow
                sm:px-6
                sm:pt-6
                border border-gray-200 dark:border-slate-700
            "
        >
            <creditscore-history :empty-state="emptyState"></creditscore-history>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useCreditScoreStore } from "@/store/creditscore";
import CreditscoreHistory from "@/charts/creditscore/history.vue";
import CreditscoreMeter from "@/charts/creditscore/meter.vue";
import LoadingState from "@/components/ui/loading-state/loading-state.vue";

export default {
    props: {
        emptyState: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CreditscoreHistory,
        CreditscoreMeter,
        LoadingState,
    },
    data: () => ({}),
    directives: {},
    computed: {
        ...mapState(useCreditScoreStore, ["userScoreData", "loadingUserCreditScore"]),
    },
    methods: {
        ...mapActions(useCreditScoreStore, [
            "setTabState",
            "openCreditScoreModal",
        ]),
    },
    mounted() {},
};
</script>
